module.exports = __webpack_public_path__ + "static/media/booking_banner.178888c8.jpg";